/* Angie's Cupcakes — theme.js */
(function () {
  'use strict';

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function makeSlider(viewport, track, opts) {
    opts = opts || {};
    var dots    = opts.dots    || [];
    var prevBtn = opts.prevBtn || null;
    var nextBtn = opts.nextBtn || null;
    var onSlide = opts.onSlide || null;
    var autoplay = opts.autoplay || 0;
    var N = track.children.length;
    if (N <= 1) return { goTo: function () {} };
    var LERP = 0.12, VEL_AMP = 0.8, SETTLE = 0.3;
    var current = 0, pos = 0, targetPos = 0, vel = 0;
    var rafId = null, isDragging = false, startX = 0, startPos = 0, hist = [];
    var autoTimer = null;

    function sw() { return viewport.offsetWidth; }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
    function setPos(x) { pos = x; track.style.transition = 'none'; track.style.transform = 'translateX(' + x + 'px)'; }
    function updateUI(idx) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (onSlide) onSlide(idx);
    }
    function animate() {
      var dist = targetPos - pos;
      if (Math.abs(dist) < SETTLE) {
        setPos(targetPos);
        var idx = clamp(Math.round(-targetPos / sw()), 0, N - 1);
        if (idx !== current) { current = idx; updateUI(idx); }
        return;
      }
      pos += dist * LERP;
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + pos + 'px)';
      var near = clamp(Math.round(-pos / sw()), 0, N - 1);
      if (near !== current) { current = near; updateUI(near); }
      rafId = requestAnimationFrame(animate);
    }
    function animateTo(tPos) { cancelAnimationFrame(rafId); targetPos = tPos; rafId = requestAnimationFrame(animate); }
    function goTo(idx) { idx = clamp(idx, 0, N - 1); current = idx; updateUI(idx); animateTo(-idx * sw()); }

    /* Snap instantané sans animation — pour le retour en boucle */
    function snapTo(idx) {
      idx = clamp(idx, 0, N - 1);
      cancelAnimationFrame(rafId);
      current = idx;
      pos = -idx * sw();
      targetPos = pos;
      setPos(pos);
      updateUI(idx);
    }

    function startAuto() {
      if (!autoplay) return;
      stopAuto();
      autoTimer = setInterval(function () {
        var next = (current + 1) % N;
        if (next === 0) {
          /* Retour à 0 : snap sans animation, puis attendre le prochain tick */
          snapTo(0);
        } else {
          goTo(next);
        }
      }, autoplay);
    }
    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }
    function resetAuto() { stopAuto(); startAuto(); }

    if (autoplay) {
      viewport.addEventListener('mouseenter', stopAuto);
      viewport.addEventListener('mouseleave', startAuto);
      startAuto();
    }

    function isInteractive(el) {
      return !!(el && el.closest && (
        el.closest('.product-gallery__arrow') ||
        el.closest('[data-gallery-prev]') ||
        el.closest('[data-gallery-next]') ||
        el.closest('[data-hero-prev]') ||
        el.closest('[data-hero-next]') ||
        el.closest('.hero-slider__cta') ||
        el.closest('a') ||
        el.closest('button')
      ));
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(current - 1); resetAuto(); });
      prevBtn.addEventListener('touchend', function (e) { e.preventDefault(); e.stopPropagation(); goTo(current - 1); resetAuto(); }, { passive: false });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(current + 1); resetAuto(); });
      nextBtn.addEventListener('touchend', function (e) { e.preventDefault(); e.stopPropagation(); goTo(current + 1); resetAuto(); }, { passive: false });
    }

    /* Pointer events : desktop uniquement */
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      if (isInteractive(e.target)) return;
      e.preventDefault();
      stopAuto();
      cancelAnimationFrame(rafId);
      pos = targetPos; setPos(pos);
      isDragging = true; startX = e.clientX; startPos = pos; vel = 0;
      hist = [{ x: e.clientX, t: performance.now() }];
      viewport.setPointerCapture(e.pointerId); viewport.classList.add('is-dragging');
    });
    viewport.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      if (!isDragging) return;
      var dx = e.clientX - startX, nx = startPos + dx, mn = -(N - 1) * sw();
      if (nx > 0) nx *= 0.3; if (nx < mn) nx = mn + (nx - mn) * 0.3;
      setPos(nx);
      var now = performance.now(); hist.push({ x: e.clientX, t: now });
      while (hist.length > 1 && now - hist[0].t > 80) hist.shift();
    });
    viewport.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'touch') return;
      if (!isDragging) return;
      isDragging = false; viewport.classList.remove('is-dragging'); viewport.releasePointerCapture(e.pointerId);
      if (hist.length >= 2) { var a = hist[0], b = hist[hist.length - 1]; vel = ((b.x - a.x) / (b.t - a.t || 1)) * 16 * VEL_AMP; } else { vel = 0; }
      if (Math.abs(e.clientX - startX) < 5) { goTo(current); resetAuto(); return; }
      var projected = pos + vel * 8, mn = -(N - 1) * sw();
      var tIdx = clamp(Math.round(-projected / sw()), 0, N - 1);
      var finalIdx = pos > 0 ? 0 : pos < mn ? N - 1 : tIdx;
      current = finalIdx; updateUI(finalIdx); animateTo(-finalIdx * sw()); resetAuto();
    });
    viewport.addEventListener('pointercancel', function (e) {
      if (e.pointerType === 'touch') return;
      if (!isDragging) return;
      isDragging = false; viewport.classList.remove('is-dragging'); goTo(current); resetAuto();
    });

    /* Touch events : mobile */
    var tSX = 0, tSY = 0, tSP = 0, tH = [], tDir = null, tActive = false;
    viewport.addEventListener('touchstart', function (e) {
      if (isInteractive(e.target)) return;
      stopAuto();
      cancelAnimationFrame(rafId);
      pos = targetPos; setPos(pos);
      tSX = e.touches[0].clientX; tSY = e.touches[0].clientY;
      tSP = pos;
      tH = [{ x: tSX, t: performance.now() }];
      tDir = null; vel = 0; tActive = true;
    }, { passive: true });
    viewport.addEventListener('touchmove', function (e) {
      if (!tActive) return;
      var dx = e.touches[0].clientX - tSX;
      var dy = e.touches[0].clientY - tSY;
      if (tDir === null) {
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 2) { tDir = 'h'; }
        else if (Math.abs(dy) > 8) { tDir = 'v'; }
        else return;
      }
      if (tDir === 'v') return;
      e.preventDefault();
      var nx = tSP + dx, mn = -(N - 1) * sw();
      if (nx > 0) nx *= 0.3; if (nx < mn) nx = mn + (nx - mn) * 0.3;
      setPos(nx);
      var now = performance.now(); tH.push({ x: e.touches[0].clientX, t: now });
      while (tH.length > 1 && now - tH[0].t > 80) tH.shift();
    }, { passive: false });
    viewport.addEventListener('touchend', function () {
      if (!tActive) return; tActive = false;
      if (tDir !== 'h') { goTo(current); setTimeout(startAuto, 3000); return; }
      if (tH.length >= 2) { var a = tH[0], b = tH[tH.length - 1]; vel = ((b.x - a.x) / (b.t - a.t || 1)) * 16 * VEL_AMP; } else { vel = 0; }
      var projected = pos + vel * 8, mn = -(N - 1) * sw();
      var tIdx = clamp(Math.round(-projected / sw()), 0, N - 1);
      var finalIdx = pos > 0 ? 0 : pos < mn ? N - 1 : tIdx;
      current = finalIdx; updateUI(finalIdx); animateTo(-finalIdx * sw());
      setTimeout(startAuto, 3000);
    }, { passive: true });
    viewport.addEventListener('touchcancel', function () {
      if (!tActive) return; tActive = false; goTo(current); setTimeout(startAuto, 3000);
    }, { passive: true });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); resetAuto(); });
    });
    viewport.setAttribute('tabindex', '0');
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(current - 1); resetAuto(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); resetAuto(); }
    });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { goTo(current); }, 150); });
    goTo(0);
    return { goTo: goTo };
  }

  function initHeroSlider() {
    var el = document.querySelector('[data-hero-slider]'); if (!el) return;
    var viewport = el.querySelector('[data-hero-viewport]'), track = el.querySelector('[data-hero-track]');
    if (!viewport || !track) return;
    makeSlider(viewport, track, {
      dots: Array.from(el.querySelectorAll('[data-hero-dot]')),
      prevBtn: el.querySelector('[data-hero-prev]'),
      nextBtn: el.querySelector('[data-hero-next]'),
      autoplay: 4500
    });
  }

  function initGallery() {
    var gallery = document.querySelector('[data-gallery]'); if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]'), track = gallery.querySelector('[data-gallery-track]');
    var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    if (!main || !track) return;
    makeSlider(main, track, {
      dots: dots,
      prevBtn: gallery.querySelector('[data-gallery-prev]'),
      nextBtn: gallery.querySelector('[data-gallery-next]'),
      onSlide: function (idx) { thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); }); }
    });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { if (dots[i]) dots[i].click(); }); });
  }

  function initProductForm() {
    var form = document.querySelector('[data-product-form]'); if (!form) return;
    var variantsEl = document.getElementById('product-variants-json'); if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var selects = form.querySelectorAll('[data-option-selector]');
    var variantInput = form.querySelector('[data-variant-id]');
    var section = form.closest('section');
    var priceEl = section && section.querySelector('[data-price]');
    var compareEl = section && section.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var isPriceDouble = !!document.getElementById('price-double-flag');
    var numberInput = document.getElementById('product-number');
    var warningEl = document.getElementById('price-double-warning');
    var isNumberXL = !!document.getElementById('needs-saveur-flag');

    function findVariant(selValues) {
      if (isNumberXL) {
        var chiffreVal = selValues[0];
        return variants.find(function (v) {
          return v.selectedOptions && v.selectedOptions.some(function (o) {
            return o.name === 'Chiffre' && o.value === chiffreVal;
          });
        });
      }
      return variants.find(function (v) {
        return selValues.every(function (val, i) {
          return v['option' + (i + 1)] === val;
        });
      });
    }

    function getNumberVal() { return numberInput ? numberInput.value.trim().replace(/\s/g, '') : ''; }
    function updateVariant() {
      var options = Array.from(selects).map(function (s) { return s.value; });
      var variant = findVariant(options); if (!variant) return;
      variantInput.value = variant.id;
      var isNombre = isPriceDouble && /^\d{2,}$/.test(getNumberVal());
      var price = isNombre ? variant.price * 2 : variant.price;
      var p = formatMoney(price);
      if (priceEl) priceEl.textContent = p;
      if (compareEl) { if (variant.compare_at_price > variant.price) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; } else { compareEl.style.display = 'none'; } }
      if (addBtn) { var btnPrice = addBtn.querySelector('[data-btn-price]'); if (btnPrice) btnPrice.textContent = p; }
      if (warningEl) warningEl.style.display = isNombre ? 'block' : 'none';
    }
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
    if (isPriceDouble && numberInput) { numberInput.addEventListener('input', updateVariant); }
    updateVariant();
  }

  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
      var trigger = accordion.querySelector('[data-accordion-trigger]');
      var body = accordion.querySelector('[data-accordion-body]');
      if (!trigger || !body) return;
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) { body.style.height = body.scrollHeight + 'px'; requestAnimationFrame(function () { body.style.height = '0'; }); trigger.setAttribute('aria-expanded', 'false'); }
        else { body.style.height = body.scrollHeight + 'px'; trigger.setAttribute('aria-expanded', 'true'); body.addEventListener('transitionend', function () { if (trigger.getAttribute('aria-expanded') === 'true') body.style.height = 'auto'; }, { once: true }); }
      });
    });
  }

  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); revealObs.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('[data-reveal]').forEach(function (el) { revealObs.observe(el); });

  document.querySelectorAll('[data-marquee]').forEach(function (el) {
    var t = el.querySelector('.marquee__track'); if (!t) return;
    el.addEventListener('mouseenter', function () { t.style.animationPlayState = 'paused'; });
    el.addEventListener('mouseleave', function () { t.style.animationPlayState = 'running'; });
  });

  var drawer = document.querySelector('[data-mobile-drawer]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  if (drawer && openBtn) {
    var open = function () { drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
    var close = function () { drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (data) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = data.item_count; el.style.display = data.item_count > 0 ? '' : 'none'; });
    }).catch(function () {});
  }

  initHeroSlider();
  initGallery();
  initProductForm();
  initAccordions();
  refreshCart();

})();
